import { z } from "zod/v4";

import { PatchUserDtoSchema, UserDtoSchema } from "../../../dtos/users";

export const PatchUserRequestBodySchema = z.object({
  user: PatchUserDtoSchema,
});

export const PatchUserResponseBodySchema = z.object({
  user: UserDtoSchema,
});

export type PatchUserRequestBodyType = z.infer<
  typeof PatchUserRequestBodySchema
>;
export type PatchUserResponseBodyType = z.infer<
  typeof PatchUserResponseBodySchema
>;
